import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { AdminFileType } from '../../../../core/interfaces/file-management-interfaces';
import { FileManagementUploadHelper } from '../../../../core/services/file-management-upload-helper.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ToastComponent } from '../../../../shared/components/toast/toast.component';

@Component({
  selector: 'app-admin-file-management-upload',
  standalone: true,
  imports: [TranslocoPipe],
  templateUrl: './admin-file-management-upload.component.html',
  styleUrl: './admin-file-management-upload.component.css'
})
export class AdminFileManagementUploadComponent implements OnInit {
  constructor(protected fileManagementHelper: FileManagementUploadHelper) {
    this.fileManagementHelper.completed$
      .pipe(takeUntilDestroyed())
      .subscribe(({ success }) => {
        if (success > 0) this.finished.emit();
      });
  }

  @Input() acceptType?: AdminFileType;
  @Input() toast?: ToastComponent;
  @Output() finished = new EventEmitter<void>();

  ngOnInit(): void {
    this.fileManagementHelper.attachToast(this.toast);
  }
}
